import React, { useState } from "react"
import Typography from "aldoo-ra/Typography"
import Input from "aldoo-ra/Input"
import Button from "aldoo-ra/Button"
import ColorPropertyEditor from "./ColorPropertyEditor"

const ColorInputPropertyEditor = ({
  property,
  value,
  onChange,
  propertyConfig,
  className = ""
}) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false)

  if (!property || !propertyConfig) return null

  const handleInputChange = (e) => {
    onChange?.(property, e.target.value)
  }

  const handleColorSelect = (color) => {
    onChange?.(property, color)
    setIsColorPickerOpen(false)
  }

  return (
    <>
      <div className={`space-y-2 ${className}`}>
        <Typography
          variant="admin_body_small"
          className="font-medium capitalize text-admin_text_secondary text-sm"
        >
          {propertyConfig.label || property}
        </Typography>
        <div className="flex gap-2">
          <Input
            variant="admin"
            value={value || ""}
            onChange={handleInputChange}
            placeholder={propertyConfig.placeholder || ""}
            debounce={300}
            className="flex-1"
          />
          <Button
            variant="admin_secondary"
            onClick={() => setIsColorPickerOpen(true)}
            className="px-3"
            style={{ backgroundColor: value || 'transparent' }}
          >
            🎨
          </Button>
        </div>
      </div>

      {/* Color Picker Modal */}
      <ColorPropertyEditor
        isOpen={isColorPickerOpen}
        onClose={() => setIsColorPickerOpen(false)}
        onColorSelect={handleColorSelect}
        currentColor={value}
        title={`Select ${propertyConfig.label || property}`}
      />
    </>
  )
}

export default ColorInputPropertyEditor